import { InvoiceStatus } from '../api'
/**
 * mapping for invoice lifecycle enum to UI panels
 */
export const invoiceMapping = {
  unpaid: [InvoiceStatus.Issued, InvoiceStatus.Declined],
  pending: [InvoiceStatus.Pending]
}
